import React from 'react'
import { ReactComponent as Ariplane } from './airplane.svg'
import styles from './QuizProgress.module.css'

const QuizProgress = props => (
  <div className={styles.base}>
    <div className={styles.track}>
      <div className={styles.progress} style={{ width: `${props.value}%` }}>
        <div className={styles.airplane}>
          <Ariplane />
        </div>
        <div className={styles.tooltip}>
          {props.current}/{props.total}
        </div>
      </div>
    </div>
  </div>
)

export default QuizProgress
